import { useEffect, useState } from "react";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { api } from "@/lib/api";

export default function ReviewsCarousel() {
  const [reviews, setReviews] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data || [])).catch(() => {});
  }, []);

  const total = reviews.length;
  const cur = total ? reviews[idx % total] : null;
  const prev = () => setIdx((i) => (i - 1 + total) % total);
  const next = () => setIdx((i) => (i + 1) % total);

  return (
    <section className="bg-surface-50 py-16 lg:py-24" data-testid="reviews-section">
      <div className="max-w-3xl mx-auto px-4 lg:px-6 text-center">
        <h2 className="text-3xl lg:text-4xl font-extrabold text-txt-900">Ce que disent nos clients</h2>
        <p className="text-txt-500 mt-2">Des centaines d'automobilistes nous font confiance chaque mois</p>

        {cur && (
          <div className="mt-10 bg-white rounded-2xl shadow-card p-8 relative" data-testid="review-card">
            <Quote size={32} className="text-brand-100 mx-auto mb-4" />
            <div className="flex justify-center gap-1 mb-4">
              {Array.from({ length: cur.rating || 5 }).map((_, i) => (
                <Star key={i} size={18} className="fill-amber-400 text-amber-400" />
              ))}
            </div>
            <p className="text-txt-700 text-lg leading-relaxed italic">"{cur.text}"</p>
            <div className="mt-5">
              <div className="font-bold text-txt-900">{cur.name}</div>
              <div className="text-sm text-txt-500">{cur.city}</div>
            </div>
          </div>
        )}

        {total > 1 && (
          <div className="flex items-center justify-center gap-4 mt-6">
            <button onClick={prev} className="w-10 h-10 border border-surface-200 hover:border-brand rounded-xl flex items-center justify-center text-txt-500 hover:text-brand transition-colors" data-testid="reviews-prev">
              <ChevronLeft size={18} />
            </button>
            <div className="flex gap-1.5">
              {reviews.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} className={`w-2 h-2 rounded-full transition-colors ${i === idx ? "bg-brand" : "bg-surface-300"}`} />
              ))}
            </div>
            <button onClick={next} className="w-10 h-10 border border-surface-200 hover:border-brand rounded-xl flex items-center justify-center text-txt-500 hover:text-brand transition-colors" data-testid="reviews-next">
              <ChevronRight size={18} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
